import type { CSSProperties } from "react";
import { Colors, findNetworkForUrl } from "schemas";
import { SocialLogos } from "./SocialLogos.ts";
import { parseLinks } from "./parseLinks.ts";

interface Props {
  links: string;
  buttonTextColor: string;
  buttonBackgroundColor: string;
}

function getIconSrc(url: string) {
  const network = findNetworkForUrl(url);
  return network
    ? SocialLogos[network]
    : {
        Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/cdb35142-de71-4cfc-d4d5-56e420478500/feed",
        Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/fcd02ae2-fe33-47c2-3e2c-312f9436ab00/feed",
      };
}

export const InlineSocialLinks = ({ links, buttonTextColor, buttonBackgroundColor }: Props) => {
  const linksArray = parseLinks(links);
  const iconVariant = buttonTextColor === Colors.Neutral0 ? "Light" : "Dark";

  return (
    <div style={{ textAlign: "center", marginBottom: "20px" }}>
      {linksArray.map((link, index) => (
        <a
          style={
            {
              display: "inline-block",
              height: "60px",
              width: "60px",
              borderRadius: "50%",
              textAlign: "center",
              marginRight: index === linksArray.length - 1 ? "0" : "16px",
              backgroundColor: buttonBackgroundColor,
            } as CSSProperties
          }
          key={link}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            style={{ marginTop: "13px", width: "32px", height: "32px" }}
            src={getIconSrc(link)[iconVariant]}
            alt="Link to sth"
          />
        </a>
      ))}
    </div>
  );
};
